var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.206,
    height: 33.206,
    viewBox: "0 0 33.206 33.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rejected",
    d: "M215.013,198.41a16.6,16.6,0,1,0,16.6,16.6,16.622,16.622,0,0,0-16.6-16.6Zm0,30.44a13.836,13.836,0,1,1,13.836-13.837A13.852,13.852,0,0,1,215.013,228.85Zm6.513-18.393-4.556,4.556,4.556,4.556a1.384,1.384,0,1,1-1.957,1.957l-4.556-4.556-4.556,4.556a1.384,1.384,0,0,1-1.956-1.957l4.556-4.556-4.556-4.556a1.384,1.384,0,1,1,1.957-1.957l4.556,4.557,4.556-4.556a1.384,1.384,0,1,1,1.957,1.956Z",
    transform: "translate(-198.41 -198.41)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.07021dfa83f5b3d4db68eef503aadc50.svg";
export { ForwardRef as ReactComponent };